import type { LucideIcon } from "lucide-react";
import { ChartNoAxesColumnIcon, PaletteIcon, ShieldIcon, UserRoundIcon } from "lucide-react";

export type SettingsNavVisibilityContext = {
  isSuperAdmin: boolean;
};

export type SettingsNavItem = {
  id: string;
  icon: LucideIcon;
  label: string;
  to: "/settings" | "/settings/account" | "/settings/usage" | "/settings/admin";
  isActive: (pathname: string) => boolean;
  visible?: (ctx: SettingsNavVisibilityContext) => boolean;
};

export const SETTINGS_NAV_ITEMS: SettingsNavItem[] = [
  {
    id: "appearance",
    icon: PaletteIcon,
    label: "Appearance",
    to: "/settings",
    isActive: (pathname) => pathname === "/settings" || pathname === "/settings/",
  },
  {
    id: "account",
    icon: UserRoundIcon,
    label: "Account",
    to: "/settings/account",
    isActive: (pathname) =>
      pathname === "/settings/account" || pathname.startsWith("/settings/account/"),
  },
  {
    id: "usage",
    icon: ChartNoAxesColumnIcon,
    label: "Usage",
    to: "/settings/usage",
    isActive: (pathname) =>
      pathname === "/settings/usage" || pathname.startsWith("/settings/usage/"),
  },
  {
    id: "admin",
    icon: ShieldIcon,
    label: "Admin",
    to: "/settings/admin",
    isActive: (pathname) =>
      pathname === "/settings/admin" || pathname.startsWith("/settings/admin/"),
    visible: (ctx) => ctx.isSuperAdmin,
  },
];

export function resolveVisibleSettingsNavItems(
  ctx: SettingsNavVisibilityContext,
): SettingsNavItem[] {
  return SETTINGS_NAV_ITEMS.filter((item) => item.visible?.(ctx) ?? true);
}
